import * as configurationApi from "src/api/configuration.js";

import { floorOff } from "assets/scripts/utilities/helpers";
import { useDealSettingStore } from "src/stores/deal-setting";

export function useRoce({ formData }) {
  const minRocePercentage = ref(2);
  const isFetchingMinRocePercentage = ref(false);
  const isDealSettingApprovalEnabled = ref(false);

  const isRoceBelowMin = computed(() => {
    return unref(formData).roce_percentage < unref(minRocePercentage);
  });

  const errorMsgForRoceField = computed(() => {
    return `ROCE should be min  ${minRocePercentage.value}%`;
  });

  const { dealSettingFormState } = storeToRefs(useDealSettingStore());

  const fetchMinRocePercentage = async () => {
    try {
      isFetchingMinRocePercentage.value = true;

      const response = await configurationApi.get();

      if (response?.data?.data?.global_settings) {
        minRocePercentage.value =
          response?.data?.data?.global_settings?.min_roce_percentage;

        isDealSettingApprovalEnabled.value = Boolean(
          response?.data?.data?.global_settings?.is_deal_setting_approval,
        );
      }

      isFetchingMinRocePercentage.value = false;
    } catch (error) {
      console.error(error);

      isFetchingMinRocePercentage.value = false;
    }
  };

  const minDelayInterest = computed(() => floorOff(0.05, 2));

  const delayInterestProps = computed(() => {
    return {
      errorMessage: `Delay Interest per day should be min  ${minDelayInterest.value}%`,
      error: unref(formData).delay_interest_percent < unref(minDelayInterest),
    };
  });

  const updateRoceValue = () => {
    const numerator =
      unref(formData).net_sales_margin_percent -
      (unref(formData).agent?.commission_percent ?? 0);

    if (typeof numerator !== "number") {
      return;
    }

    const denominator =
      unref(formData).virtual_credit_cycle +
      unref(formData).grace_period -
      unref(formData).grn_payment_delay_days;

    if (typeof denominator !== "number" || !denominator) {
      return;
    }

    formData.value.roce_percentage = floorOff(numerator * (30 / denominator));
  };

  const getMinDelayInterest = () => {
    if (typeof unref(formData).roce_percentage === "number") {
      return floorOff(0.05, 2);
    }

    return 0;
  };

  watchEffect(async () => {
    if (unref(dealSettingFormState).open) {
      await fetchMinRocePercentage();
    }
  });

  return {
    minRocePercentage,
    isFetchingMinRocePercentage,
    isDealSettingApprovalEnabled,
    updateRoceValue,
    getMinDelayInterest,
    errorMsgForRoceField,
    isRoceBelowMin,
    delayInterestProps,
  };
}
